import { forwardRef, type ReactNode } from 'react';
import cx from 'classnames';

import { useStyles } from './useStyles';

interface LayoutContainerCenteredProps {
  className?: string;
  children?: ReactNode;
}

export const LayoutContainerCentered = forwardRef<HTMLDivElement, LayoutContainerCenteredProps>(
  ({ className, children, ...props }, ref) => {
    const styles = useStyles();

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
        {...props}
      >
        {children}
      </div>
    );
  }
);
